import {inject, Injectable} from "@angular/core";
import {HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {ApiService} from "../services";
import {finalize} from "rxjs";
import {environment} from "@env/environment";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private apiService = inject(ApiService);

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const shouldIgnore = this.apiService.ignoreLoadingIndicatorUrls.some(pattern => {
      const regex = new RegExp(pattern);
      const url = req.url.replace(environment.apiBaseUrl, '');
      return regex.test(url);
    });

    if (shouldIgnore) {
      return next.handle(req);
    }

    this.apiService.isLoading.set(true);

    return next.handle(req).pipe(
      finalize(() => this.apiService.isLoading.set(false)),
    );
  }
}
